export enum UpdateType {
  UPGRADED = 'upgraded',
  DOWNGRADED = 'downgraded',
}
